import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { BusinessRuleBase } from '../../business/BusinessBase';
import { GenericValidation } from '../../../../../../../validations/GenericValidation';

const {
  formField: { principalAddress },
} = loanFormModel;

export class PrincipalAddressValidation implements ValidationSchema {
  public name = principalAddress.name;
  public label = principalAddress.label;
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalAddress.requiredErrorMsg,
    value: principalAddress.required,
  };
  public nullable = true;

  public when(schema: any, context: any) {
    const bl = new BusinessRuleBase(context.parent);
    if (bl.isPrincipal() && !bl.isTrust())
      return schema.required(principalAddress.requiredErrorMsg);

    return GenericValidation.create({
      nullable: true,
      required: false,
    });
  }
}
export default new Validation(new PrincipalAddressValidation());
